import React, { Component } from 'react'
import { connect } from 'react-redux'
import { selectService } from 'store/selectedService'
import SceneCopy from 'components/SceneCopy'
import TransitionGroup from 'react-transition-group/TransitionGroup'
import PropTypes from 'prop-types'

class SceneCopyContainer extends Component {
  constructor (props) {
    super(props)
    this.onClickCallback = this.onClickCallback.bind(this)
  }

  onClickCallback (serviceID) {
    this.props.selectService(serviceID)
  }

  render () {
    return (
      <TransitionGroup component='div'>
        {
          (this.props.isHome && !this.props.siteMenuVisible) &&
          <SceneCopy
            listedServices={this.props.listedServices}
            selectedService={this.props.selectedService}
            onClickCallback={this.onClickCallback} />
        }
      </TransitionGroup>
    )
  }
}

SceneCopyContainer.propTypes = {
  listedServices: PropTypes.array,
  selectedService: PropTypes.number,
  isHome: PropTypes.bool,
  siteMenuVisible: PropTypes.bool,
  selectService: PropTypes.func
}

const mapDispatchToProps = {
  selectService: (serviceID) => selectService(serviceID)
}

const mapStateToProps = (state) => ({
  listedServices: state.listedServices,
  selectedService: state.selectedService,
  siteMenuVisible: state.siteMenuVisible
})

export default connect(mapStateToProps, mapDispatchToProps)(SceneCopyContainer)



// WEBPACK FOOTER //
// ./src/containers/SceneCopyContainer/index.js